module.exports = __webpack_public_path__ + "static/media/foundations.4af13af7.svg";